import React from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTranscriberListControllerAdminTranscriberListQuery } from '@shared/services/apiService/apiService';
import { TranscriberTable } from '../components/TranscriberTable';
import { useTranscriberContext } from '../TranscriberContext';
import { useEffect } from 'react';

import { TranscriberCreateDialog } from '../components/TranscriberCreateDialog';
import { TranscriberDeleteDialog } from '../components/TranscriberDeleteDialog';

import './ManageTranscriberPageContent.css';

export const ManageTranscriberPageContent: React.FC = () => {
  const { openDialog, refreshKey } = useTranscriberContext();
  const { t } = useTranslation();
  const {
    isLoading: isLoadingTranscribers,
    refetch: refreshTranscribers,
    data: transcribers,
  } = useTranscriberListControllerAdminTranscriberListQuery();

  useEffect(() => {
    refreshTranscribers();
  }, [refreshKey]);

  const handleAddTranscriberClick = () => {
    openDialog('createOpen');
  };

  return (
    <>
      <Box className="addTranscriberBox">
        <Button variant="contained" color="primary" onClick={handleAddTranscriberClick}>
          {t('transcriberPage.actions.addTranscriber')}
        </Button>
      </Box>

      {isLoadingTranscribers && (
        <Box className="centeredBox">
          <CircularProgress />
        </Box>
      )}

      {!transcribers && (
        <Box className="centeredBox">
          <Typography variant="h6">{t('superAdminManageVoice.noData')}</Typography>
        </Box>
      )}

      {transcribers && transcribers.length > 0 && <TranscriberTable transcribers={transcribers} />}

      <TranscriberCreateDialog />

      <TranscriberDeleteDialog />
    </>
  );
};
